import { yupResolver } from '@hookform/resolvers/yup';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';

import fitsTableIdentificationFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fits/IdentificationFormMeta';
import fitTableMaxDigitCheckedFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fits/MaxPinDigitCheckedFormMeta';
import fitTableMaxPinDigitsEntryFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fits/MaxPinDigitsEntryFormMeta';
import fitTablePanPadFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fits/PanPadFormMeta';
import fitTablePinPadFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fits/PinPadFormMeta';
import { IFitsNextFormMeta } from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fitsNext/FitsNextFormMeta';
import flagSensorMMFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fitsNext/FlagSensorMMFormMeta';
import gbpFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fitsNext/GBPFormMeta';
import indexReferencePointFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fitsNext/IndexReferencePointFormMeta';
import miscFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fitsNext/MiscFormMeta';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  meta: IFitsNextFormMeta,
} & TFormUIProps;

const FitsNextFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CC.SimpleGrid
        columns={{ base: 1, lg: 2 }}
        gridRowGap={4}
        columnGap={10}
        my={4}
      >
        <CustomFieldSet title="Index Point Référence">
          <CC.SimpleGrid
            columns={{ base: 1, lg: 2 }}
            gridRowGap={4}
            columnGap={10}
            my={4}
          >
            {displayCustomInputs<IFitsNextFormMeta>(
              indexReferencePointFormMeta,
              register,
              errors,
              isLoading
            )}
          </CC.SimpleGrid> 
        </CustomFieldSet>

        <CC.SimpleGrid
            columns={1}
            gridRowGap={4}
            columnGap={10}
           
          >
            <CustomFieldSet title="Flag Sensor MM">
              {displayCustomInputs<IFitsNextFormMeta>(
                flagSensorMMFormMeta,
                register,
                errors,
                isLoading
              )}
            </CustomFieldSet>

            <CustomFieldSet title="Misc.">
              {displayCustomInputs<IFitsNextFormMeta>(
                miscFormMeta,
                register,
                errors,
                isLoading
              )}
            </CustomFieldSet>

            <CustomFieldSet title="GBP" my={4}>
              {displayCustomInputs<IFitsNextFormMeta>(
                gbpFormMeta,
                register,
                errors,
                isLoading
              )}
            </CustomFieldSet>

          </CC.SimpleGrid>
      </CC.SimpleGrid>

      <CC.HStack my={8} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default FitsNextFormUI;
